import { render } from "./BaseTextarea.vue?vue&type=template&id=f9c49ae2&scoped=true"
import script from "./BaseTextarea.vue?vue&type=script&lang=js"
export * from "./BaseTextarea.vue?vue&type=script&lang=js"

import "./BaseTextarea.vue?vue&type=style&index=0&id=f9c49ae2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9c49ae2"]])

export default __exports__